import './App.css';

function App() {
  return (
    <div className="app">
      <header>
         <div className="avatar">
              <img src="https://media-exp1.licdn.com/dms/image/C4D03AQFgsQyyG2gKpg/profile-displayphoto-shrink_400_400/0/1650870149063?e=1668038400&v=beta&t=c6LZI8kbLx4f4pi1M-Bmr-AiZgeshh_LIRlP0rZMGMY" alt="" />
         </div>
         <div className="Name">
            <h1>Tallapragada Abhishek</h1>
            <h2>Computer Science Student</h2>
         </div>
      </header>
    
      <div className="links">
         <div className="Linkedin"> 
           <a href="https://www.linkedin.com/in/abhishek-tallapragada-883378187/overlay/background-image/"><p>linkedin</p></a>
         </div>
         <div className="Twitter"> 
           <a href="https://twitter.com/Abhisshek5"><p>Twitter</p></a>
         </div>
         <div className="Github"> 
           <a href="https://github.com/Abhisshek717"><p>Github</p></a>
         </div>
      </div>
    </div>
  );
}

export default App;
